import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { utilitiesAction } from "../redux/utilities-slice";

const useReporting = () => {
   const dispatch = useDispatch();

   const reportingService = useCallback(
      (text = "", type = "info") =>
         dispatch(
            utilitiesAction.setReporting({
               text: text,
               isReporting: true,
               type: type,
            })
         ),
      [dispatch]
   );

   const apiErrorReportingService = useCallback(
      (response) => {
         const error_text =
            response?.data?.responseMessage ?? "something went wrong";
         reportingService(error_text, "error");
      },
      [reportingService]
   );
   return { reportingService, apiErrorReportingService };
};

export default useReporting;
